import { FC } from 'react';

import { Button, Icon } from '@components';
import CurrencyAmount from '@components/currency-amount/CurrencyAmount';

interface PaymentSuccessProps {
  amount: number | null;
  handleCancel: () => void;
  handleViewDetails?: () => void;
}

const PaymentSuccess: FC<PaymentSuccessProps> = ({
  amount,
  handleCancel,
  handleViewDetails
}) => (
  <div className="text-center">
    <div className="mb-1 flex justify-center">
      <div className="rounded-full p-4">
        <div className="mt-4 rounded-full p-4">
          <Icon name="payment-success" size="none" className="size-48" />
        </div>
      </div>
    </div>

    <div className="text-center font-medium text-gray-900">
      <p className="text-xl">Payment marked as paid</p>
      <p className="text-xl">successfully!</p>
      <p className="mt-2 text-lg font-semibold text-black">
        <CurrencyAmount
          value={amount}
          className="justify-center gap-1"
          symbolClass="!font-normal"
          valueClass="!font-medium pl-1"
        />
      </p>
    </div>

    <div className="mt-10 flex justify-center gap-4">
      <Button
        label="View Details"
        variant="secondary"
        className="w-96"
        handleClick={handleViewDetails}
      />
      <Button
        label="Done"
        variant="primary"
        className="w-96"
        handleClick={handleCancel}
      />
    </div>
  </div>
);

export default PaymentSuccess;
